module.exports = __webpack_public_path__ + "img/logo.a09e628d.png";